import * as LoadingStatus from '@dragonfruit/constants/loadingState';

import fileDefaultObject from '@snapask/common-components/dist/constants/uploadFileSchemaForZendesk';

export const types = {
  SUBMIT_REPORT_REQUEST: 'SUBMIT_REPORT_REQUEST',
  SUBMIT_REPORT_SUCCESS: 'SUBMIT_REPORT_SUCCESS',
  SUBMIT_REPORT_FAILURE: 'SUBMIT_REPORT_FAILURE',

  UPLOAD_FILE_REQUEST: 'UPLOAD_FILE_REQUEST',
  UPLOAD_FILE_SUCCESS: 'UPLOAD_FILE_SUCCESS',
  UPLOAD_FILE_FAILURE: 'UPLOAD_FILE_FAILURE',

  REMOVE_FILE_REQUEST: 'REMOVE_FILE_REQUEST',

  TOGGLE_REPORT_FORM: 'TOGGLE_REPORT_FORM',
  HIDE_REPORT_FORM: 'HIDE_REPORT_FORM',
  SAVE_CURRENT_DATA: 'SAVE_CURRENT_DATA',
  SET_REPORT_TAGS: 'SET_REPORT_TAGS',
  SET_REPORT_OPTIONS: 'SET_REPORT_OPTIONS',
  RESET_REPORT_OPTIONS: 'RESET_REPORT_OPTIONS',
};

export const actions = {
  submitReport: (email, reportMessage, options) => ({
    type: types.SUBMIT_REPORT_REQUEST,
    payload: {
      email,
      reportMessage,
      options,
    },
  }),
  submitReportSuccess: () => ({
    type: types.SUBMIT_REPORT_SUCCESS,
  }),
  submitReportFailed: () => ({ type: types.SUBMIT_REPORT_FAILURE }),
  uploadFile: file => ({
    type: types.UPLOAD_FILE_REQUEST,
    payload: {
      file,
    },
  }),
  uploadFileSuccess: file => ({
    type: types.UPLOAD_FILE_SUCCESS,
    payload: {
      file,
    },
  }),
  uploadFileFailed: () => ({ type: types.UPLOAD_FILE_FAILURE }),
  removeFile: token => ({
    type: types.REMOVE_FILE_REQUEST,
    payload: {
      token,
    },
  }),
  toggleReportForm: () => ({
    type: types.TOGGLE_REPORT_FORM,
  }),
  hideReportForm: () => ({ type: types.HIDE_REPORT_FORM }),
  saveCurrentData: ({ email, message }) => ({
    type: types.SAVE_CURRENT_DATA,
    payload: {
      email,
      message,
    },
  }),
  setReportOptions: options => ({
    type: types.SET_REPORT_OPTIONS,
    payload: { options },
  }),
  resetReportOptions: () => ({
    type: types.RESET_REPORT_OPTIONS,
  }),
};

const INITIAL_STATE = {
  loadingState: LoadingStatus.EMPTY,
  files: [],
  options: {
    projectName: '',
    tags: [],
  },
  isReportFormOpen: false,
  isReportFormEnable: true,
  email: '',
  message: '',
};

/*eslint-disable complexity */
const reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.SUBMIT_REPORT_REQUEST:
      return {
        ...state,
        loadingState: LoadingStatus.LOADING,
      };
    case types.SUBMIT_REPORT_SUCCESS:
      return {
        ...INITIAL_STATE,
        loadingState: LoadingStatus.READY,
      };
    case types.SUBMIT_REPORT_FAILURE:
      return {
        ...state,
        loadingState: LoadingStatus.ERROR,
      };
    case types.UPLOAD_FILE_REQUEST: {
      const file = Object.assign(fileDefaultObject(), {
        name: action.payload.file.name,
        isUploading: true,
      });
      return {
        ...state,
        loadingState: LoadingStatus.LOADING,
        files: state.files.concat([file]),
      };
    }
    case types.UPLOAD_FILE_SUCCESS: {
      state.files.pop();
      const file = Object.assign(fileDefaultObject(), action.payload.file);
      return {
        ...state,
        loadingState: LoadingStatus.READY,
        files: state.files.concat([file]),
      };
    }
    case types.UPLOAD_FILE_FAILURE:
      return {
        ...state,
        loadingState: LoadingStatus.ERROR,
      };
    case types.REMOVE_FILE_REQUEST:
      return {
        ...state,
        loadingState: LoadingStatus.LOADING,
        files: state.files.filter(file => file.token !== action.payload.token),
      };
    case types.TOGGLE_REPORT_FORM:
      return {
        ...state,
        isReportFormOpen: !state.isReportFormOpen,
      };
    case types.HIDE_REPORT_FORM:
      return {
        ...state,
        isReportFormEnable: false,
      };
    case types.SAVE_CURRENT_DATA:
      return {
        ...state,
        email: action.payload.email,
        message: action.payload.message,
      };
    case types.SET_REPORT_OPTIONS:
      return {
        ...state,
        options: {
          ...state.options,
          ...action.payload.options,
        },
      };

    case types.RESET_REPORT_OPTIONS:
      return {
        ...state,
        options: INITIAL_STATE.options,
      };

    default:
      return state;
  }
};

export default reducer;

export const getFiles = state => state.report.files;
export const getIsReportFormOpen = state => state.report.isReportFormOpen;
export const getIsReportFormEnable = state => state.report.isReportFormEnable;
export const getEmail = state => state.report.email;
export const getMessage = state => state.report.message;
export const getReportOptions = state => state.report.options;



// WEBPACK FOOTER //
// ./app/redux/report.js